import React, {Component} from 'react';
import './Contacts.css'

const $ = window.jQuery;

class Contacts extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    componentDidMount() {
        this.$bgEl = $(this.bgEl);
        this.$bgEl.pxResponsiveBg({
            backgroundImage: '/assets/img/header_pallets.jpg',
            overlay: '#000'
        });
    }

    render() {
        return (
            <div>
                <div ref={el => this.bgEl = el}
                    className="page-about-us-header page-header m-b-0 b-b-0 text-xs-center bg-default px-responsive-bg-container">
                    <h1 className="m-b-1 font-size-28 font-weight-bold">NetPallet</h1>
                    <br/>
                    <span className="font-size-18 font-weight-semibold">Единственная в своём роде тендерная площадка для паллет</span>
                </div>
                <div className="page-wide-block">
                    <div className="box m-a-0 valign-middle border-radius-0 text-xs-center font-size-14">
                        <a href="https://www.facebook.com/NetPallet-2003084016681633/" className="box-cell col-md-4 p-x-1 p-y-2 text-white"
                           style={{background: '#4867b4'}}>
                            <i className="fa fa-facebook"/>&nbsp;&nbsp;NetPallet
                        </a>
                        <a href="tel:74996475062" className="box-cell col-md-4 p-x-1 p-y-2 text-white"
                           style={{background: '#00aff0'}}>
                            <i className="fa fa-phone"/>&nbsp;&nbsp;+7 (499) 647-50-62
                        </a>
                        <a href="mailto:info@nepal.ru" className="box-cell col-md-4 p-x-1 p-y-2 text-white"
                           style={{background: '#888'}}>
                            <i className="fa fa-envelope"/>&nbsp;&nbsp;info@nepal.ru
                        </a>
                    </div>
                </div>
                <div className="page-about-us-text page-block panel m-y-0 b-a-0 border-radius-0 font-size-16">
                    <div className="m-x-auto" style={{maxWidth: '800px'}}>
                        <p>
                            Pellentesque sit amet urna eu nibh semper facilisis id quis nisl. Mauris
                            semper nunc ut mauris tincidunt luctus. Curabitur a venenatis ante. Duis
                            massa purus, convallis non eros at, tincidunt bibendum mi. In fermentum
                            finibus sapien in venenatis.
                        </p>
                        <p>
                            Morbi tempor ipsum vel placerat maximus. Donec
                            hendrerit iaculis lacus vel gravida. Sed id diam id nisi fermentum porta
                            a vel tellus. Suspendisse malesuada pharetra quam a fermentum. Cras euismod
                            sem eu neque ultrices iaculis. Suspendisse sed purus ut nunc interdum vehicula
                            non quis quam. Nam elementum dapibus quam, ac vestibulum urna. Suspendisse
                            vel iaculis nisi. Vivamus mollis nibh sem, eget hendrerit diam feugiat ut.
                            Maecenas condimentum facilisis tellus sed ultricies.
                        </p>
                        <p>
                            Etiam mollis, est a condimentum eleifend, velit lorem scelerisque arcu,
                            quis consectetur elit ante eu risus.
                        </p>
                    </div>
                </div>
                <div className="page-wide-block m-b-4">
                    <div className="box border-radius-0 m-a-0">
                        <div className="box-cell col-md-4 col-lg-3 p-x-4 p-y-3 valign-middle bg-black">
                            <h4 className="m-t-0">NetPallet</h4>
                            <div>
                                <small><strong>Россия, г. Москва, Куркинское шоссе</strong></small>
                            </div>
                            {/*<div>*/}
                                {/*<small>БЦ "Челябинск-Сити", офис 304</small>*/}
                            {/*</div>*/}
                        </div>
                        <div className="box-cell col-md-8 col-lg-9" style={{height: '150px'}}>
                            <div className="widget-maps" id="contacts-map" style={{overflow: 'hidden'}}>
                                <iframe style={{width: '100%', border: 0}}
                                        frameBorder="0"
                                        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCeQwuAsTRCmNNIz8an7Sk1QGdlOLkx3fk&language=ru&q=г. Москва, Куркинское шоссе"
                                        allowFullScreen>
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 className="m-y-4 p-t-4 text-xs-center">Наша команда</h3>
                <div className="row">
                    <div className="col-md-6">
                        <div className="panel box">
                            <div className="page-about-us-team-avatar box-cell p-y-3 p-l-3 valign-top">
                                <img src="/assets/demo/avatars/4.jpg" alt="" className="border-round"/>
                            </div>
                            <div className="box-cell p-y-2 p-x-3 valign-middle">
                                <div className="font-size-14"><strong>Михаил Черников</strong></div>
                                <p className="text-muted font-size-11 font-weight-semibold text-uppercase">Консультант
                                    по
                                    стратегии</p>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent condimentum
                                    maximus lectus eget auctor.
                                </p>
                                <div>
                                    <a href="#" className="text-muted"><i
                                        className="fa fa-twitter"></i></a>&nbsp;&nbsp;&nbsp;
                                    <a href="#" className="text-muted"><i
                                        className="fa fa-facebook"></i></a>&nbsp;&nbsp;&nbsp;
                                    <a href="#" className="text-muted"><i className="fa fa-google-plus"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="panel box">
                            <div className="page-about-us-team-avatar box-cell p-y-3 p-l-3 valign-top">
                                <img src="/assets/demo/avatars/1.jpg" alt="" className="border-round"/>
                            </div>
                            <div className="box-cell p-y-2 p-x-3 valign-middle">
                                <div className="font-size-14"><strong>Дмитрий Чушков</strong></div>
                                <p className="text-muted font-size-11 font-weight-semibold text-uppercase">Управляющий
                                    директор</p>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent condimentum
                                    maximus lectus eget auctor.
                                </p>
                                <div>
                                    <a href="#" className="text-muted"><i
                                        className="fa fa-twitter"></i></a>&nbsp;&nbsp;&nbsp;
                                    <a href="#" className="text-muted"><i
                                        className="fa fa-facebook"></i></a>&nbsp;&nbsp;&nbsp;
                                    <a href="#" className="text-muted"><i className="fa fa-google-plus"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="panel box">
                            <div className="page-about-us-team-avatar box-cell p-y-3 p-l-3 valign-top">
                                <img src="/assets/demo/avatars/2.jpg" alt="" className="border-round"/>
                            </div>
                            <div className="box-cell p-y-2 p-x-3 valign-middle">
                                <div className="font-size-14"><strong>Тимур Рахматиллаев</strong></div>
                                <p className="text-muted font-size-11 font-weight-semibold text-uppercase">Ведущий
                                    разработчик</p>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent condimentum
                                    maximus lectus eget auctor.
                                </p>
                                <div>
                                    <a href="#" className="text-muted"><i
                                        className="fa fa-twitter"></i></a>&nbsp;&nbsp;&nbsp;
                                    <a href="#" className="text-muted"><i
                                        className="fa fa-facebook"></i></a>&nbsp;&nbsp;&nbsp;
                                    <a href="#" className="text-muted"><i className="fa fa-google-plus"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contacts;


// WEBPACK FOOTER //
// ./src/pages/Contacts/Contacts.js